// hooks/useLoadGoogleMaps.js
import { useEffect, useState } from 'react';

export function useLoadGoogleMaps() {
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const existingScript = document.querySelector('#google-maps-script');
        if (existingScript) {
            if (window.google) setLoaded(true);
            else {
                existingScript.addEventListener('load', () => setLoaded(true));
            }
            return;
        }

        const lang = localStorage.getItem('language');
        const apiKey = 'AIzaSyCJnwtgouEbCjmQtDqOyi3EepSD-iyxLhY';
        const baseUrl = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
        const langParams = lang === 'sr' ? '&language=sr-Latn&region=RS' : '&language=en&region=US';

        const script = document.createElement('script');
        script.src = baseUrl + langParams;
        script.async = true;
        script.defer = true;
        script.id = 'google-maps-script';

        script.onload = () => setLoaded(true);
        document.body.appendChild(script);

        return () => {
            if (script) document.body.removeChild(script);
        };
    }, []);

    return loaded;
}
